/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../client.ts';
import type {
  TelegramProductsControllerFindSellerPublicProductsQueryResponse,
  TelegramProductsControllerFindSellerPublicProductsPathParams,
  TelegramProductsControllerFindSellerPublicProductsQueryParams,
  TelegramProductsControllerFindSellerPublicProducts401,
} from '../types/TelegramProductsControllerFindSellerPublicProducts.ts';

function getTelegramProductsFindSellerPublicProductsUrl(
  sellerPublicProfileId: TelegramProductsControllerFindSellerPublicProductsPathParams['sellerPublicProfileId'],
) {
  const res = { method: 'GET', url: `/api/telegram/products/seller/${sellerPublicProfileId}/products` as const };
  return res;
}

/**
 * {@link /api/telegram/products/seller/:sellerPublicProfileId/products}
 */
export async function telegramProductsFindSellerPublicProducts(
  sellerPublicProfileId: TelegramProductsControllerFindSellerPublicProductsPathParams['sellerPublicProfileId'],
  params: TelegramProductsControllerFindSellerPublicProductsQueryParams,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    TelegramProductsControllerFindSellerPublicProductsQueryResponse,
    ResponseErrorConfig<TelegramProductsControllerFindSellerPublicProducts401>,
    unknown
  >({
    method: 'GET',
    url: getTelegramProductsFindSellerPublicProductsUrl(sellerPublicProfileId).url.toString(),
    params,
    ...requestConfig,
  });
  return res.data;
}
